// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartCatalogAddCard-modulecard__tC2A0 FileUploadPlaceholder-moduleFileUploadPlaceholder__LRagJ";
var _2 = "BirdviewChartCatalogAddCard-modulelabel__TKl23";
var _3 = "BirdviewChartCatalogAddCard-moduletext__u_Uqk";
export { _1 as "card", _2 as "label", _3 as "text" }
